module.exports = __webpack_public_path__ + "img/Staying-organized-&-keeping-track-of-your-recipes-with-Dropsmart.1407b004.png";